import { useIndexedDB } from "hooks/useIndexedDb";
import { Database } from "utils";
import { ButtonH } from "../../../../../../UiKit/ButtonH";
import { Ico } from "../../../../../../Uikit";
import { PopoverH } from "../../../../../../UiKit/PopoverH";
import React from "react";
import { useIsEnglishUi } from "utils/uiLanguage";

export const ClearDB = () => {
  const en = useIsEnglishUi();
  const { deleteAll } = useIndexedDB(Database.name);
  const handleClear = () => {
    console.log("handleClear", Database.videoTable);
    deleteAll(Database.videoTable);
    deleteAll(Database.audioTable);
  };

  return (
    <PopoverH
      placement="top"
      title={
        <div className="_fv _fgap2 _f100">
          <div className="_fv _f100 _r04 _pd1" style={{ backgroundColor: "rgb(233,233,233)" }}>
            <div className="">
              {en
                ? "Delete audio and video downloaded into this browser"
                : "Удалить скачанные аудио и видео из этого браузера"}
            </div>

            <div className="_f100 _fcc">
              <ButtonH onClick={handleClear}>{en ? "Clear" : "Очистить"}</ButtonH>
            </div>
          </div>
        </div>
      }
    >
      <ButtonH sm ghost>
        <Ico size={"16"}>delete</Ico>
        {en ? "Clear" : "Очистить"}
      </ButtonH>
    </PopoverH>
  );
};
